import { townsEpic as epic } from "./epic";
import { townsReducer as reducer } from "./reducer";

export const townsEpic = epic
export const townsReducer = reducer
